import React, { createContext, useContext, useEffect, useReducer, useState } from "react";
import { getCookie, deleteCookie } from "../helper/cookie";
import { getMyProfile, getSiteSettings, getP2PSettings, getMyFuturesBalance, getMySpotUsdtBalance, getMyEarnUsdtBalance } from "./helper";
import authReducer from "./reducer";
import Config from "../config";
import { makeRequest } from "../services/v1/request";
import { getUserReferralData } from "../services/all.api";

const initialState = {
  siteSettings: null,
  myProfile: null,
  p2pSettings: null,
  futuresBalance: null,
  spotBalance: null,
  earnBalance: null,
};

const AuthContext = createContext();

const useContextData = () => {
  const context = useContext(AuthContext);
  // console.log('context----', context)
  if (context === undefined) {
    throw new Error(`Context missing provider`);
  }
  return context;
};

const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const [coindcxDecimal, setCoindcxDecimal] = useState([]);
  const [referralLoading, setReferralLoading] = useState(true)
  const [profileLoading, setProfileLoading] = useState(true)
  const [spotUsdtLoading, setSpotUsdtLoading] = useState(true)
  const [earnUsdtLoading, setEarnUsdtLoading] = useState(true)
  const [spotPnl, setSpotPnl] = useState([]);
  const [planAmount1, setPlanAmount1] = useState(null)
  const [referralId, setReferralId] = useState(null)
  const [referralData, setReferralData] = useState([]);
  const [spotBalPortfolio, setSpotBalPortfolio] = useState({
    loader: true,
    data: []
  });
  const getMarketDetails = async () => {
    const params = {
      url: `${Config.V1_API_URL}trade/getMarketDetails`,
      method: "GET",
    };
    const response = await makeRequest(params);
    if (response.status) {
      const dataTable = {};
      response.message.forEach(item => {
        dataTable[item.coindcx_name] = item;
      });
      setCoindcxDecimal(() => dataTable)

    }
  }
  const getPnlSpot = async () => {
    const params = {
      url: `${Config.V1_API_URL}spot-signal/get-pnl-spot-signal`,
      method: "GET",
    };

    const response = await makeRequest(params);
    if (response.status) {
      setSpotPnl(() => response?.data)
    }
  }
  const getSpotUsdtBalancePortfolio = async () => {
    setSpotBalPortfolio((el) => { return { ...el, loader: true } })
    const params = {
      url: `${Config.V3_API_URL}trade/get-spot-balance-portfolio`,
      method: "GET",
    };

    const response = await makeRequest(params);
    if (response.status) {
      setSpotBalPortfolio((el) => { return { ...el, loader: false, data: response?.data, estimated: response?.estimated } })
    }
    setSpotBalPortfolio((el) => { return { ...el, loader: false } })
  }
  const getReferralData = async (currentUser = state?.myProfile) => {
    setReferralLoading(true)
    const stakeData = await getUserReferralData(currentUser?._id)
    if (stakeData.status && (stakeData.data).length > 0) {
      setReferralData(() => stakeData.data[0])
    }
    else {
      setReferralData(() => [])
    }
    setReferralLoading(false)
  }
  useEffect(() => {
    async function apiForContext() {
      const settings = await getSiteSettings();
      if (settings.status) {
        dispatch({
          type: 'SET_SITE_SETTINGS',
          payload: settings.message
        });
      }
      const p2psettings = await getP2PSettings();
      if (p2psettings.status) {
        dispatch({
          type: 'SET_P2P_SETTINGS',
          payload: p2psettings.data
        });
      }
      if (getCookie('userToken')) {
        let userData = await setUserProfile();
        setFuturesBalance()
        // setSpotUsdtBalance()
        getSpotUsdtBalancePortfolio()
        if (!userData) {
          await deleteCookie('userToken');
          window.location.reload();
        }
      }
    }
    apiForContext();
    getMarketDetails();
    getPnlSpot();
  }, []);

  const setFuturesBalance = async () => {
    const balance = await getMyFuturesBalance();
    if (balance.status) {
      dispatch({
        type: 'SET_FUTURES_BALANCE',
        payload: balance.data?.coin?.[0]
      });
      return true;
    } else {
      return false;
    }
  }
  const setSpotUsdtBalance = async (pair) => {
    setSpotUsdtLoading(true)
    const balance = await getMySpotUsdtBalance(pair);
    if (balance.status) {
      dispatch({
        type: 'SET_SPOT_BALANCE',
        payload: balance.data
      });
      setSpotUsdtLoading(false)
      return true;
    } else {
      return false;
    }
  }
  const setEarnUsdtBalance = async () => {
    setEarnUsdtLoading(true)
    const balance = await getMyEarnUsdtBalance();
    if (balance.status) {
      dispatch({
        type: 'SET_EARN_BALANCE',
        payload: balance.data
      });
      setEarnUsdtLoading(false)
      return true;
    } else {
      return false;
    }
  }
  const setUserProfile = async () => {
    setProfileLoading(() => true)
    const profile = await getMyProfile();
    if (profile.status) {
      dispatch({
        type: 'SET_MY_PROFILE',
        payload: profile.data
      });
      getReferralData(profile.data)
      setFuturesBalance()
      // setSpotUsdtBalance()
      getSpotUsdtBalancePortfolio()
      setEarnUsdtBalance()
      setProfileLoading(() => false)
      return true;
    } else {
      setProfileLoading(() => false)
      return false;
    }
  }

  const stateInfo = {
    ...state,
    setUserProfile,
    dispatch,
    coindcxDecimal,
    spotPnl,
    setFuturesBalance,
    setSpotUsdtBalance,
    profileLoading,
    spotUsdtLoading,
    setSpotUsdtLoading,
    spotBalPortfolio,
    setSpotBalPortfolio,
    getSpotUsdtBalancePortfolio,
    setEarnUsdtBalance,
    earnUsdtLoading,
    planAmount1,
    setPlanAmount1,
    referralId,
    setReferralId,
    getReferralData,
    referralData,
    referralLoading
  };
  return (
    <AuthContext.Provider value={stateInfo}>{children}</AuthContext.Provider>
  );
}
export { useContextData, AuthProvider };
